import React from 'react';
import { Layout as AntdLayout } from 'antd';
import ReduxRedirect from '../../Common/ReduxRedirect';

import styles from './index.module.scss';

export default function Simple({ children }: React.PropsWithChildren): JSX.Element {
  return (
    <>
      <ReduxRedirect />
      <AntdLayout>
        <AntdLayout.Content className={styles.content}>{children}</AntdLayout.Content>
      </AntdLayout>
    </>
  );
}
